// Core
import { http } from "@/network/http-provider";

// Definitions
import type {
  IPromoFieldFetch,
  LoginParamsType,
  OtpVerifyParamsType,
  RecoveryPasswordParamsType,
  RegisterParamsType,
} from "./types";
import { HttpRequestParams } from "@/types/http";

// Utils
import { authKeys } from "./apiKeys";

export const authApi = Object.freeze({
  fetchLogin: (payload: LoginParamsType) => {
    const { data } = payload;
    return http.post<any>(authKeys.login, data);
  },
  fetchOtpVerify: (payload: OtpVerifyParamsType) => {
    const { data } = payload;
    return http.post<any>(authKeys.otpVerify, data);
  },
  fetchRecoveryPassword: (payload: RecoveryPasswordParamsType) => {
    const { data } = payload;
    return http.post<any>(authKeys.restore, data);
  },
  fetchRegister: (payload: RegisterParamsType) => {
    const { data } = payload;
    return http.post<any>(authKeys.register, data);
  },
  fetchPromo: (payload: HttpRequestParams<void, IPromoFieldFetch>) => {
    const { params } = payload;
    return http.get<any>(`${authKeys.promo}/${params?.country}`);
  },
});
